import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MetricCardComponent } from 'src/app/core/components/metric-card';
import { EmailCoverageResponse } from 'src/app/core/models/analytics/es-models';

@Component({
  selector: 'app-es-protection-coverage-cards',
  standalone: true,
  imports: [CommonModule, MetricCardComponent],
  templateUrl: './es-protection-coverage-cards.component.html',
  styleUrl: './es-protection-coverage-cards.component.scss',
})
export class EsProtectionCoverageCardsComponent {
  emailCoverage = input<EmailCoverageResponse>();
}
